/**
 * طبلية عز (Tablet Ezz) — Custom Shopify Theme Core JS
 * Handles AJAX Cart, Mobile Navigation, Free Shipping Meter, and Theme Editor Integration
 */

(function () {
  'use strict';

  // State
  let cart = {
    items: [],
    item_count: 0,
    total_price: 0
  };

  // DOM Cache
  const drawer = document.getElementById('CartDrawer');
  const backdrop = document.getElementById('DrawerBackdrop');
  const cartBadges = document.querySelectorAll('[data-cart-count]');
  const drawerItems = document.getElementById('DrawerCartItems');
  const drawerSubtotal = document.getElementById('DrawerSubtotal');
  const emptyNotice = document.getElementById('DrawerEmptyNotice');
  const drawerBody = document.getElementById('DrawerBodyContent');
  const drawerFooter = document.getElementById('DrawerFooter');
  const drawerWhatsAppBtn = document.getElementById('DrawerWhatsAppBtn');
  const meterWrap = document.getElementById('CartShippingMeter');
  const meterText = document.getElementById('ShippingMeterText');
  const meterFill = document.getElementById('ShippingMeterFill');

  // Open / Close Drawer
  window.openCartDrawer = function () {
    if (drawer && backdrop) {
      drawer.classList.add('active');
      backdrop.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  };

  window.closeCartDrawer = function () {
    if (drawer && backdrop) {
      drawer.classList.remove('active');
      backdrop.classList.remove('active');
      document.body.style.overflow = '';
    }
  };

  document.querySelectorAll('[data-cart-open]').forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      window.openCartDrawer();
    });
  });

  document.querySelectorAll('[data-cart-close]').forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      window.closeCartDrawer();
    });
  });

  if (backdrop) {
    backdrop.addEventListener('click', window.closeCartDrawer);
  }

  // Toast System
  window.showToast = function (message) {
    const toast = document.getElementById('ToastNotification');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('active');
    setTimeout(() => toast.classList.remove('active'), 3200);
  };

  // Currency Formatter
  function formatMoney(cents) {
    return (cents / 100).toFixed(0) + ' ج.م';
  }

  // Update Free Shipping Meter
  function updateShippingMeter(totalCents) {
    if (!meterWrap || !meterText || !meterFill) return;
    const thresholdEgp = parseInt(meterWrap.getAttribute('data-threshold') || '500', 10);
    const totalEgp = totalCents / 100;
    const diff = thresholdEgp - totalEgp;

    if (diff <= 0) {
      meterText.innerHTML = '<span>🎉 مبروك! حصلت على <strong>شحن مجاني</strong></span> 🚚';
      meterFill.style.width = '100%';
    } else {
      meterText.innerHTML = '<span>🚚 باقي <strong>' + diff.toFixed(0) + ' ج.م</strong> على التوصيل المجاني!</span>';
      const pct = Math.min(100, Math.max(5, (totalEgp / thresholdEgp) * 100));
      meterFill.style.width = pct + '%';
    }
  }

  // Render Cart Drawer
  function renderCart(cartData) {
    cart = cartData;
    
    // Update count badges across header and mobile dock
    cartBadges.forEach(b => {
      b.textContent = cart.item_count || 0;
      b.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });

    if (!drawerItems || !drawerSubtotal) return;

    drawerSubtotal.textContent = formatMoney(cart.total_price || 0);
    updateShippingMeter(cart.total_price || 0);

    // Empty state
    if (cart.item_count === 0) {
      if (emptyNotice) emptyNotice.style.display = 'block';
      if (drawerBody) drawerBody.style.display = 'none';
      if (drawerFooter) drawerFooter.style.display = 'none';
      drawerItems.innerHTML = '';
      return;
    }

    if (emptyNotice) emptyNotice.style.display = 'none';
    if (drawerBody) drawerBody.style.display = 'block';
    if (drawerFooter) drawerFooter.style.display = 'flex';

    // Render Line items
    let html = '';
    cart.items.forEach((item, idx) => {
      const imgUrl = item.featured_image ? (item.featured_image.url || item.featured_image) : '';
      const unitOrVariant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      
      html += `
        <div class="cart-item" data-line="${idx + 1}" data-key="${item.key || item.id}">
          ${imgUrl ? `<img src="${imgUrl}" class="cart-item-img" alt="${item.title}" width="68" height="68" loading="lazy">` : `<div class="cart-item-img" style="background:#FAF7F2;display:flex;align-items:center;justify-content:center;font-size:24px;">🍲</div>`}
          <div class="cart-item-details">
            <div style="display:flex;justify-content:space-between;align-items:flex-start;gap:8px;">
              <div>
                <div class="cart-item-title">${item.product_title || item.title}</div>
                ${unitOrVariant ? `<div class="cart-item-variant">${unitOrVariant}</div>` : ''}
              </div>
              <button type="button" class="btn-item-remove" data-remove-item="${item.key || item.id}" aria-label="حذف المنتج">✕</button>
            </div>
            <div class="cart-item-bottom">
              <div class="qty-stepper">
                <button type="button" data-qty-change="-1" data-id="${item.key || item.id}" aria-label="تقليل">-</button>
                <span>${item.quantity}</span>
                <button type="button" data-qty-change="1" data-id="${item.key || item.id}" aria-label="زيادة">+</button>
              </div>
              <div class="current-price">${formatMoney(item.final_line_price || (item.price * item.quantity))}</div>
            </div>
          </div>
        </div>
      `;
    });

    drawerItems.innerHTML = html;

    // Build WhatsApp Order Link
    if (drawerWhatsAppBtn && drawer) {
      const waNumber = drawer.getAttribute('data-whatsapp-number') || '201000000000';
      let waMsg = 'أهلاً طبلية عز! 🍲\nحابب أطلب الأوردر ده:\n\n';
      cart.items.forEach(item => {
        waMsg += `• ${item.quantity} × ${item.product_title || item.title} (${formatMoney(item.final_line_price || (item.price * item.quantity))})\n`;
      });
      waMsg += `\nالمجموع: ${formatMoney(cart.total_price)}`;
      drawerWhatsAppBtn.href = `https://wa.me/${waNumber}?text=${encodeURIComponent(waMsg)}`;
    }

    // Attach Stepper Listeners
    drawerItems.querySelectorAll('[data-qty-change]').forEach(btn => {
      btn.addEventListener('click', function () {
        const id = this.getAttribute('data-id');
        const diff = parseInt(this.getAttribute('data-qty-change'), 10);
        const item = cart.items.find(i => (i.key || i.id) == id);
        if (item) {
          const newQty = item.quantity + diff;
          updateQuantity(id, newQty < 0 ? 0 : newQty);
        }
      });
    });

    // Attach Remove Listeners
    drawerItems.querySelectorAll('[data-remove-item]').forEach(btn => {
      btn.addEventListener('click', function () {
        const id = this.getAttribute('data-remove-item');
        updateQuantity(id, 0);
      });
    });
  }

  // Fetch Cart from Shopify API
  function fetchCart() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(data => renderCart(data))
      .catch(() => {});
  }

  // Update Item Quantity
  function updateQuantity(id, qty) {
    if (drawerItems) drawerItems.style.opacity = '0.5';
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty })
    })
      .then(r => r.json())
      .then(data => renderCart(data))
      .catch(() => window.showToast('حدث خطأ أثناء تحديث الكمية.'))
      .finally(() => {
        if (drawerItems) drawerItems.style.opacity = '1';
      });
  }

  // Global Add to Cart
  window.tablyetAddToCart = function (variantId, title, priceCents, imgUrl, variantTitle) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(r => {
        if (!r.ok) throw new Error('Add failed');
        return r.json();
      })
      .then(() => {
        fetchCart();
        window.openCartDrawer();
        window.showToast('تمت الإضافة للسلة بنجاح! 🍲');
      })
      .catch(() => window.showToast('حدث خطأ أثناء الإضافة للسلة.'));
  };

  // Intercept Native Form Submissions
  document.addEventListener('submit', function (e) {
    const form = e.target.closest('form[action*="/cart/add"], .product-form');
    if (!form) return;

    e.preventDefault();
    const submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.style.opacity = '0.7';
    }

    const formData = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
      .then(r => {
        if (!r.ok) throw new Error('Add failed');
        return r.json();
      })
      .then(() => {
        fetchCart();
        window.openCartDrawer();
        window.showToast('تمت الإضافة للسلة بنجاح! 🍲');
      })
      .catch(() => window.showToast('حدث خطأ أثناء الإضافة للسلة.'))
      .finally(() => {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.style.opacity = '1';
        }
      });
  });

  // Debounced Order Notes Autosave
  const cartNotesInput = document.getElementById('CartOrderNotes');
  if (cartNotesInput) {
    let noteDebounce;
    cartNotesInput.addEventListener('input', function () {
      clearTimeout(noteDebounce);
      noteDebounce = setTimeout(() => {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: cartNotesInput.value })
        }).catch(() => {});
      }, 600);
    });
  }

  // Hero Slider
  function initHeroSliders() {
    document.querySelectorAll('.hero-slider-wrap').forEach(slider => {
      const slides = slider.querySelectorAll('.hero-slide');
      if (slides.length <= 1) return;
      let cur = 0;
      setInterval(() => {
        slides[cur].style.display = 'none';
        cur = (cur + 1) % slides.length;
        slides[cur].style.display = 'block';
      }, 5000);
    });
  }

  // Collection Filter Pills (Instant Filter)
  function initCategoryFilters() {
    const filterButtons = document.querySelectorAll('.filter-pill-btn');
    if (!filterButtons.length) return;

    filterButtons.forEach(btn => {
      btn.addEventListener('click', function () {
        filterButtons.forEach(b => b.classList.remove('active'));
        this.classList.add('active');

        const selectedCat = this.getAttribute('data-filter');
        const items = document.querySelectorAll('.collection-product-wrapper');

        items.forEach(item => {
          const itemType = item.getAttribute('data-product-type') || '';
          const itemTags = item.getAttribute('data-product-tags') || '';
          if (!selectedCat || selectedCat === 'all' || itemType.includes(selectedCat) || itemTags.includes(selectedCat)) {
            item.style.display = 'block';
          } else {
            item.style.display = 'none';
          }
        });
      });
    });
  }

  // Theme Editor Re-initialization Hooks
  document.addEventListener('shopify:section:load', function (e) {
    initHeroSliders();
    initCategoryFilters();
    fetchCart();
  });

  // DOM Ready Initializer
  document.addEventListener('DOMContentLoaded', function () {
    fetchCart();
    initHeroSliders();
    initCategoryFilters();
  });

})();
